export function telno2intl(telno) {
		let out = {
			ton: 0,
			telno: "",
		};

		let m = telno.match(/([^0-9\+])/);
		if (m !== null) {
			// obsahuje ine znaky ako cisla alebo plus
			if (telno.length <= 11) {
				out.ton = 5; // Telno::ALPHANUMERIC
				out.telno = telno;
			} else {
				out.ton = -1; // Telno::INVALID
				out.telno = telno;
			}
			return out;
		}

		m = telno.match(/^(0|00421|\+421|421)([2-9][0-9]{8})$/);
		if (m !== null) {
			// slovenske narodne cislo (zacina 2-9, dlzka 9 znakov) s medzinarodnou predvolbou alebo narodnou predvolbou
			out.ton = 1; // Telno::INTERNATIONAL
			out.telno = "421" + m[2];
			return out;
		}

		m = telno.match(/^(00420|\+420|420)?([67][0-9]{8})$/);
		if (m !== null) {
			// ceske narodne cislo (zacina 2-9, dlzka 9 znakov) s medzinarodnualebo bez
			out.ton = 1; // Telno::INTERNATIONAL
			out.telno = "420" + m[2];
			return out;
		}

		m = telno.match(/^(00|\+)?([1-9][0-9]{10,})$/);
		if (m !== null) {
			// medzinarodne cislo s predvobou alebo bez
			out.ton = 1; // Telno::INTERNATIONAL
			out.telno = m[2];
		} else {
			out.ton = 0; // Telno::UNKNOWN
			out.telno = telno;
		}
		return out;
	}